import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { UserInfo } from 'src/app/store/actions/user.action';
import { AppState } from 'src/app/store/app.states';

@Component({
  selector: 'app-innerpage',
  templateUrl: './innerpage.component.html',
  styleUrls: ['./innerpage.component.scss']
})
export class InnerpageComponent implements OnInit {

  
  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.store.dispatch(new UserInfo())
  }

}
